import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-user-certificate',
  standalone: false,
  templateUrl: './user-certificate.component.html',
  styleUrl: './user-certificate.component.scss',
})
export class UserCertificateComponent implements OnInit, AfterViewInit {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  commentForm: FormGroup;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  apiUrl = environment.APIUrl;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  rfpdata: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedFileName: string = '';
  file: File;
  selectedFinalOfferFile: File | null = null;
  finalOfferFilePath: string | null = null;
  @Input() schemeType: string;
  userID: any;

  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName,
      };
    });
    this.commentForm = this.fb.group({
      final_offer: ['', Validators.required],
      date: ['', Validators.required],
    });
    this.getRfpDetails();
  }

  goToNextStep() {
    this.stepCompleted.emit();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  getRfpDetails() {
    let url = `/revenue/user/certificated/`;
    this.api
      .getAPI(
        url +
          `?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe((res: any) => {
        if (res?.length > 0) {
          this.rfpdata = res[0];

          this.commentForm.patchValue({
            final_offer: this.rfpdata?.comment || '',
            date: this.rfpdata?.date || '',
          });

          this.finalOfferFilePath = this.rfpdata?.certificated || null; // <-- set existing file path
          this.selectedFinalOfferFile = null; // clear any previously selected file
          // this.commentForm.disable();
        }
      });
  }

  onUpload(event: any): void {
    const file = event.files?.[0];
    this.file = file;
    if (!file) return;
    this.selectedFinalOfferFile = file;
  }

  onSubmit(): void {
    // if (this.commentForm.valid) {
    let vendor_id = sessionStorage.getItem('final_vendor');
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('vendor_id', vendor_id);
    formData.append('comment', this.commentForm.get('final_offer').value);
    formData.append('date', this.commentForm.get('date').value);

    if (this.file) {
      formData.append('certificated', this.file);
    }
    let url = `/revenue/user/certificated/`;

    if (this.rfpdata?.id) {
      this.api
        .putAPI(url + this.rfpdata?.id + '/', formData)
        .subscribe((res: any) => {
          this.finalOfferFilePath = res?.file || null;
          this.selectedFinalOfferFile = null;

          this.getRfpDetails();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Data updated successfully',
          });
        });
    } else {
      this.api.postAPI(url, formData).subscribe((res: any) => {
        this.selectedFinalOfferFile = null;
        this.finalOfferFilePath = res?.file || null;
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Data  uploaded successfully',
        });
        // this.stepCompleted.emit();
      });
    }
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: 'Proposal Name', value: this.payload.proposal_name },
        { key: 'Comment', value: this.commentForm.get('final_offer')?.value },
        { key: 'Date', value: this.commentForm.get('date')?.value },
      ],
    };
    this.generatePDFEmitter.emit(payload);
  }
  extractFileName(path: string): string {
    const fileName = path.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }

  clearUpload() {
    this.selectedFinalOfferFile = null;
  }
}
